import { Badge as MuiBadge } from '@mui/material'

const Badge = ({ badgeContent, children, color, ...props }) => {
	return (
		<MuiBadge badgeContent={badgeContent} color={color} {...props}>
			{children}
		</MuiBadge>
	)
}

Badge.defaultProps = {
	...MuiBadge.defaultProps,
	color: 'primary',
}

Badge.propTypes = {
	...MuiBadge.propTypes,
}

export default Badge
